import { get } from 'lodash'
import { trackClick, trackMORS } from '../lib/fpti-analytics'

const getBasePath = (requestURI) => {
  const browserPath = get(window, 'location.pathname', '')
  const countryRegex = new RegExp(`(/[a-zA-Z][a-zA-Z2])?(${requestURI})`)
  let basePath = requestURI

  if (!browserPath.startsWith(requestURI, 0)) {
    const regexResult = countryRegex.exec(browserPath) || []
    basePath =
      regexResult.length > 1 ? `${regexResult[1]}${requestURI}` : requestURI
  }
  return basePath
}

const loadFraudnetConfig = (options) => {
  try {
    const script = document.createElement('script')
    script.src = options.fraudnetSrc
    script.setAttribute('nonce', options.nonce)
    document.body.appendChild(script)
  } catch (e) {
    // Ignore
  }
}

/**
 * Base click handler for:
 * 1) tracking purposes
 * 2) open a new window by passing a url
 * 3) native device sharing capability
 * @param method HTTP method like GET, POST, etc.
 * @param trackingUrl URL to be called
 * @param deviceSharing = { text: '', title: '', url: '' }
 */
const handleClick = async (
  {
    fptiTracking,
    morsClickTrackingUrl = '',
    url = null,
    target = '_self',
    deviceSharing = null,
  },
  event,
) => {
  event.preventDefault()
  const element = event.currentTarget,
    link = element.getAttribute('data-name')
  trackClick({
    options: {
      ...fptiTracking,
      link,
    },
  })
  if (morsClickTrackingUrl) {
    trackMORS({
      method: 'GET',
      url: morsClickTrackingUrl,
    })
  }
  if (deviceSharing) {
    try {
      await navigator.share(deviceSharing)
    } catch (err) {
      console.error(err)
    }
  }
  if (url) {
    window.open(url, target)
  }
}

const copyToClipboard = async (value) => {
  try {
    await navigator.clipboard.writeText(value)
  } catch (error) {
    console.error(error)
  }
}
export { copyToClipboard, getBasePath, loadFraudnetConfig, handleClick }
